import { createSlice, PayloadAction, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import {RunningPeriodsApi}  from "../RunningPeriods/api";
import { AlarmData} from "../Common/Types/types";
import { RootState } from "../Core/Store";

const initialVeryShortCount:any = [];

interface countSliceState {
    veryShortCount:any[];
    loadingState?: string;
    errorMessage?: string;
}

const initialState: countSliceState = {
    veryShortCount:initialVeryShortCount,
    loadingState: undefined,
    errorMessage: undefined,
};

export const fetchVeryShortCount = createAsyncThunk<any,any>(
    "veryShortCount/fetchVeryShortCount",
    async (params:any) => {
      const response = await RunningPeriodsApi.getRunningPeriodCount(params)
      //
      return response;
    }
); 


const countSlice = createSlice({
    name: "veryShortCount",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      //
      builder.addCase(fetchVeryShortCount.fulfilled, (state, action) => {
        return {
          ...state,
          loadingState: "fulfilled",
          errorMessage: undefined,
          veryShortCount: [...action.payload],
        };
      });
      builder.addCase(fetchVeryShortCount.rejected, (state, action) => {
        return {
          ...state,
          loadingState: "rejected",
          errorMessage: "error",
        };
      });
      builder.addCase(fetchVeryShortCount.pending, (state, action) => {
        return {
          ...state,
          loadingState: "pending",
          errorMessage: undefined,
        };
      });
    },
  });
  
export const getVeryShortCountSelector = (state: RootState) => state.veryShortCount.veryShortCount;
export const getVeryShortCountLoadingSelector = (state: RootState) => state.veryShortCount.loadingState;

export default countSlice.reducer;